function selectDefinedValue(...values) {
  return values.find((value) => value !== undefined)
}

function selectDefinedNonNullValue(...values) {
  return values.find((value) => value !== undefined && value !== null)
}

export default function mergeCharacterCombatantStatusUpdate({
  existingCombatant,
  storeCombatant,
  incomingCombatant,
}) {
  const baseCombatant = existingCombatant || storeCombatant || {}

  return {
    ...baseCombatant,
    id: selectDefinedValue(incomingCombatant?.id, baseCombatant.id),
    slug: selectDefinedValue(incomingCombatant?.slug, baseCombatant.slug),
    name: selectDefinedValue(incomingCombatant?.name, baseCombatant.name),
    image: selectDefinedNonNullValue(incomingCombatant?.image, baseCombatant.image),
    image_name: selectDefinedNonNullValue(incomingCombatant?.image_name, baseCombatant.image_name),
    status: selectDefinedValue(incomingCombatant?.status, baseCombatant.status),
    sub_status: selectDefinedValue(incomingCombatant?.sub_status, baseCombatant.sub_status),
    fatigue: selectDefinedValue(incomingCombatant?.fatigue, baseCombatant.fatigue),
    sr: selectDefinedValue(incomingCombatant?.sr, baseCombatant.sr),
    sr_adj: selectDefinedValue(incomingCombatant?.sr_adj, baseCombatant.sr_adj),
    dex: selectDefinedValue(incomingCombatant?.dex, baseCombatant.dex),
    ca: selectDefinedValue(incomingCombatant?.ca, baseCombatant.ca),
  }
}
